/**
 * Moves currently-selected string options to the top of the list,
 * preserving the relative order of both the selected and unselected groups.
 */
export const moveSelectedStringsToTop = (options: string[], selectedValues: string[]): string[] => {
  if (!Array.isArray(selectedValues) || selectedValues.length === 0) {
    return options;
  }
  const selectedSet = new Set(selectedValues);
  const selected = options.filter((option) => selectedSet.has(option));
  const rest = options.filter((option) => !selectedSet.has(option));
  return [...selected, ...rest];
};

/**
 * Normalizes the selected specialities into a string array, guarding against
 * non-array values coming from filter state.
 */
export const toSelectedSpecialities = (selectedValues: unknown): string[] => {
  return Array.isArray(selectedValues) ? (selectedValues as string[]) : [];
};

/**
 * Filters reason-for-visit options by the (already lower-cased) search term,
 * then floats selected options to the top so they remain visible when the
 * list is collapsed to its first N items.
 */
export const getFilteredReasonForVisitOptions = (
  options: string[],
  searchTerm: string,
  selectedValues: unknown,
): string[] => {
  const matched = options.filter((option) => option.toLowerCase().includes(searchTerm));
  return moveSelectedStringsToTop(matched, toSelectedSpecialities(selectedValues));
};
